import React, { useEffect, useState } from 'react' 
import { Button, Intent } from '@blueprintjs/core'
import { __ } from '@libs/utilities'  
import { IProject } from '@/modules/pe-fest-module/data/interfaces'
import { isRole } from '@/settings/zustand/user'
import actions from '@/modules/pe-basic-module/data/actions'
import { UPDATE_SINGLE_TYPE } from '@/modules/pe-basic-module/data/actionTypes'
import { useFestProjects } from '@/modules/pe-fest-module/data/store'
import { useParams } from 'react-router'

interface ICorrectNominationProps {
    item: IProject
}

const CorrectNomination = (props: ICorrectNominationProps) : JSX.Element => {
    const {landId} = useParams()
    const[isEdit, setEdit] = useState(false)
    const [nomination, setNomination] = useState(props.item.nomination)
    useEffect(() =>
    {
        setNomination( props.item.nomination )
    }, [props.item.nomination]) 
    const onNomination = () =>
    {
        // actions -- correct notification
        const data = {
            data_type: "PEFestProject",
            id: props.item.id,
            item: { nomination },
            landId: landId
        }
        actions(UPDATE_SINGLE_TYPE, data).then( (resp: IProject) => {
            console.log( resp.nomination )
            const currentProject = useFestProjects.getState().currentProject
            const setCurrentProject = useFestProjects.getState().setCurrentProject
            setEdit( false ) 
            setCurrentProject({
                ...currentProject,
                nomination: resp.nomination
            })
        })
        
    }
    const edit = () =>
    {
        return <div className="d-flex align-items-center " data-testid="correct-nomination-edit">
            <input 
                type="string"
                className='form-control0 input dark w_350'
                value={nomination}
                onChange={ (evt) => setNomination( evt.currentTarget.value )}
                data-testid="correct-nomination-edit-title"
            />
            <Button
                intent={Intent.SUCCESS}
                icon="tick"
                variant="minimal"
                className='hint hint--top'
                data-hint={__("Save")}
                onClick={onNomination}
                data-testid="correct-nomination-edit-save"
            />
            <Button
                intent={Intent.DANGER}
                icon="cross"
                variant="minimal"
                className='hint hint--top'
                data-hint={__("Cancel")}
                onClick={ () => setEdit( false ) }
                data-testid="correct-nomination-edit-cancel"
            />
        </div>
    }
    const noEdit = () =>
    {
        return <div className="row align-items-center " data-testid="correct-nomination">
            <div className="text-nowrap mx-3">
                { props.item.nomination }
            </div>
            <div className=" ">
                <Button
                    variant="minimal"
                    fill
                    icon="edit"
                    onClick={ () => setEdit( true ) }
                    data-testid="correct-nomination-edit-edit"
                />
            </div>
        </div>
    }
    return isRole([ "administrator", "track_moderator", "School_guardian" ])
        ?
        isEdit ? edit() : noEdit()
        :
        <>{props.item.nomination}</>
}

CorrectNomination.propTypes = {}

export default CorrectNomination